import { render, staticRenderFns } from "./RegNewStudent.vue?vue&type=template&id=0986b2b2"
import script from "./RegNewStudent.vue?vue&type=script&lang=js"
export * from "./RegNewStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports